export const platformClient = require("purecloud-platform-client-v2/dist/node/purecloud-platform-client-v2.js");